import React from 'react';
import { Provider } from 'react-redux';
import { CombinedReducerStore } from "../../../../javascript/store";
import FormLoginModal from "./form_login_modal";

export default class Login extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return <Provider store={CombinedReducerStore}>
            <FormLoginModal closeLogin = {this.props.onCloseLogin}
                            userLogin = {this.props.onUserLogin}
                            action = {this.props.action} />
           </Provider>
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/login.js